/*
 * Pick the injected wallet provider, preferring MetaMask.
 *
 * When two extensions are installed they race to own window.ethereum, and the
 * loser logs:
 *
 *   MetaMask encountered an error setting the global Ethereum provider — this is
 *   likely due to another Ethereum wallet extension also setting the global
 *   Ethereum provider: TypeError: Cannot set property ethereum of #<Window>
 *
 * After that, window.ethereum is whichever extension won — often not the one the
 * user actually uses — so on-chain reads (balances, Chainlink) and chain
 * switching silently target the wrong wallet or fail outright.
 *
 * EIP-5749 has the losers publish themselves on window.ethereum.providers, so
 * when that array exists we can still find MetaMask. Wallet *selection* proper
 * goes through EIP-6963 in WalletPickerModal — this is only for the legacy
 * `window.ethereum` fallback paths, so those stop being a coin flip.
 */
export function getInjectedProvider() {
  const eth = typeof window !== 'undefined' ? window.ethereum : null;
  if (!eth) return null;
  if (Array.isArray(eth.providers) && eth.providers.length) {
    return eth.providers.find((p) => p && p.isMetaMask) || eth.providers[0];
  }
  return eth;
}

/** True when more than one extension is injecting — the state that causes the above. */
export function hasProviderConflict() {
  const eth = typeof window !== 'undefined' ? window.ethereum : null;
  return Boolean(eth && Array.isArray(eth.providers) && eth.providers.length > 1);
}
